import { Rule } from 'antd/es/form';
import { AddressTranscription } from '../constants/transcription.constant';

export type IComunaStateCLSelectOption = {
  value: string;
  label: string;
  code: string;
};

export const MAX_ADDRESS_QUANTITY = 5;
export const stateFieldRules: Rule[] = [{ required: true, message: AddressTranscription.STATE_RULE_REQUIRED }];
export const neighborhoodFieldRules: Rule[] = [{ required: true, message: AddressTranscription.COMUNA_RULE_REQUIRED }];
export const streetFieldRules: Rule[] = [
  { min: 3, message: AddressTranscription.STREET_RULE_MIN },
  { max: 30, message: AddressTranscription.STREET_RULE_MAX },
  { required: true, message: AddressTranscription.STREET_RULE_REQUIRED },
];

export const streetNumberFieldRules: Rule[] = [
  { min: 1, message: AddressTranscription.STREET_NUMBER_RULE_MIN },
  { max: 6, message: AddressTranscription.STREET_NUMBER_RULE_MAX },
  { required: true, message: AddressTranscription.STREET_NUMBER_RULE_REQUIRED },
];

export const blockNumberFieldRules: Rule[] = [
  { min: 1, message: AddressTranscription.BLOCK_NUMBER_RULE_MIN },
  { max: 6, message: AddressTranscription.BLOCK_NUMBER_RULE_MAX },
  { required: true, message: AddressTranscription.BLOCK_NUMBER_RULE_REQUIRED },
];
